// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonRedo_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.62247 11.5663C0.412945 8.95644 1.68298 6.33519 4.10127 4.93899C7.44932 3.00599 11.7304 4.15312 13.6634 7.50117L15.3955 6.50117L14.7974 11.4653L10.1993 9.50117L11.9314 8.50117C10.5507 6.10971 7.49273 5.29033 5.10127 6.67104C3.68461 7.48895 2.81962 8.89543 2.63685 10.4033L0.62247 11.5663Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.34614 13.11C3.9451 11.3269 5.17176 9.7466 6.92884 8.73216C10.7552 6.52302 15.6479 7.83402 17.857 11.6604L14.3929 13.6604L21.7231 16.3565L23.0532 8.66036L19.5891 10.6604C16.8277 5.87743 10.7118 4.23868 5.92884 7.00011C3.09552 8.63593 1.36554 11.4489 1 14.4646L3.34614 13.11Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonRedo is a generated icon component.
 */
let IconCommonRedo = IconCommonRedo_1 = class IconCommonRedo extends IconBaseElement {
    render() {
        return html `${IconCommonRedo_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonRedo.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonRedo = IconCommonRedo_1 = __decorate([
    customElement('zui-icon-common-redo')
], IconCommonRedo);
export { IconCommonRedo };
